import ContentArea from 'components/content-area/ContentArea';
import Link from 'components/link/Link';
import RichText from 'components/rich-text/RichText';
import RichTextWithTitle from 'components/rich-text-with-title/RichTextWithTitle';
import Process from 'components/process/Process';
import DownloadList from 'components/download-list/DownloadList';

import { IRichTextWithTitle, ITabContentSection } from 'source/NFR.types';

const textList = (texts: IRichTextWithTitle[], headingLevel?: number) =>
  texts.length > 0
    ? texts.map(text => (
        <div className="tab-content-section--text" key={text.title}>
          <RichTextWithTitle headingLevel={headingLevel} {...text} />
        </div>
      ))
    : null;

const TabContentSection: React.FC<ITabContentSection> = ({
  content,
  contentDescription,
  downloadList,
  ingress,
  application,
  moreContent,
  title,
  moreTexts = [],
  texts = [],
  process,
  htmlId
}) => {
  return (
    <div className="tab-content-section">
      {title && (
        <h2 id={htmlId} data-epi-type="title" className="tab-content-section-title">
          {title}
        </h2>
      )}
      {ingress && <RichText className="tab-content-section--ingress" {...ingress} />}
      {process && <Process {...process} />}
      {textList(texts, 2)}
      {contentDescription && (
        <div className="tab-content-section--description">
          <RichTextWithTitle {...contentDescription} />
        </div>
      )}
      {content && (
        <div data-epi-type="content">
          <ContentArea
            className="tab-content-section--content"
            additionalComponentProps={{
              DescriptionListBlock: { headingLevel: 3 },
              TableBlock: { headingLevel: 3 }
            }}
            {...content}
          />
        </div>
      )}
      {textList(moreTexts)}
      {application && (
        <div className="tab-content-section--text">
          {application.title && <h2>{application.title}</h2>}
          <p>{application.text}</p>
          {application.link && (
            <Link className="tab-content-section--link" theme="primary" {...application.link} useButtonStyles />
          )}
        </div>
      )}
      {downloadList && <DownloadList className="tab-content-section--downloads" {...downloadList} />}
      {moreContent && (
        <div data-epi-type="content">
          <ContentArea className="tab-content-section--content" {...moreContent} />
        </div>
      )}
    </div>
  );
};

TabContentSection.displayName = 'TabContentSection';

export default TabContentSection;
